export const roleTemplatesPageMessages = {
  title: 'Role Templates',
  subtitle: 'Browse and manage role templates for your stories',
  errorLoading: 'Failed to load role templates',
  noTemplatesFound: 'No role templates found',
  noTemplatesDescription:
    'Role templates will appear here when they are created.',
  deleteSuccess: 'Role template deleted successfully',
  deleteErrorMessage: 'Failed to delete role template',
  deleteConfirm: 'Are you sure you want to delete this role template?',
  deleteConfirmTitle: 'Delete Role Template',
  deleteErrorInUse:
    'Cannot delete this role template because it is being used in one or more story templates. Please remove it from all story templates first.',
  createButton: 'Create Role Template',
} as const;
